import { HEX_COLOR_RE } from '../BrandIdentity/brandingShared';

/** Default hex colors baked into `interactive.svg` (Figma preview placeholders — not Atlas theme tokens). */
export const ONBOARDING_BRAND_PREVIEW_SVG_DEFAULTS = {
  primary: '#465FA3',
  secondary: '#4A5463',
} as const;

/** @deprecated Use ONBOARDING_BRAND_PREVIEW_SVG_DEFAULTS */
export const ONBOARDING_BRAND_PREVIEW_DEFAULTS = ONBOARDING_BRAND_PREVIEW_SVG_DEFAULTS;

/** Normalize hex input while typing — auto-prefix `#` and strip invalid characters. */
export function normalizeHexColorInput(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed === '') return '';

  let value = trimmed;
  if (!value.startsWith('#') && /^[0-9A-Fa-f]/.test(value)) {
    value = `#${value}`;
  }

  if (!value.startsWith('#')) {
    return value;
  }

  const hex = value
    .slice(1)
    .replace(/[^0-9A-Fa-f]/g, '')
    .slice(0, 6);
  return `#${hex}`;
}

/** Lenient parser for live preview swatches (3- or 6-digit hex, with or without `#`). */
export function parseHexColorForPreview(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  const match = withHash.match(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/);
  if (!match) return null;

  const hex = match[1];
  if (hex.length === 3) {
    return `#${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`.toLowerCase();
  }
  return `#${hex}`.toLowerCase();
}

export function resolveBrandPreviewColor(
  value: string,
  fallback: string,
): string {
  const parsed = parseHexColorForPreview(value);
  if (parsed) return parsed;
  const trimmed = value.trim();
  return HEX_COLOR_RE.test(trimmed) ? trimmed : fallback;
}
